export default __webpack_public_path__ + "static/media/VISUAL_AND_PERFORMING_ARTS_MUSIC.06385884.svg";